import { DocumentType } from '../../../types'

export const getEventNameFromDocumentType = (documentType: DocumentType): string | undefined => {
  switch (documentType) {
    case 'ID_FRONT':
      return undefined
    case 'ID_BACK':
      return 'Uploaded ID'
    case 'PASSPORT':
      return 'Uploaded Passport'
    default:
      return undefined
  }
}
